export default () => {
  document.addEventListener('click', (e) => {
    const target = e.target.closest('[data-btn-my-account]');
    if (target) {
      const preheaderDropdown = document.querySelector('[data-preheader-dropdown]');
      if (preheaderDropdown) {
        preheaderDropdown.classList.toggle('reveal');
      }
    }
  });
};
